import { computed, type ComputedRef } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/system/user'
import { useClientStore } from '@/stores/system/client'

/**
 * AAR-1494 — Sichtbarkeit des Moduls *Persoenliche Buchungskonten*
 * (Profil-Button *Meine Konten*, Personen-*Konten*-Tab, Route myAccounts).
 *
 * Gating analog Gebaeude-Buchhaltung, zusaetzlich ERP-gescoped:
 *  - ERP-Gate (hart): nur Karthago / hpPsql (clientStore.canPersonalAccounts).
 *  - Client-Setting: nicht ausgeblendet (hide_personal_accounts).
 *  - Rollen-Gate: Admin/Team ODER role.personal_accounts.
 */
function hasPersonalAccountsRolePermission(permissions: unknown): boolean {
	return (
		Array.isArray(permissions) &&
		permissions.some((p: any) => p?.role?.personal_accounts === true)
	)
}

/** Reaktive Variante fuer Komponenten (v-if / Tab-Gating). */
export function usePersonalAccountsAccess(): {
	canViewPersonalAccounts: ComputedRef<boolean>
} {
	const { isAdmin, isTeam, permissions } = storeToRefs(useUserStore())
	const { canPersonalAccounts, settings } = storeToRefs(useClientStore())

	const canViewPersonalAccounts = computed(
		() =>
			canPersonalAccounts.value === true &&
			settings.value?.hide_personal_accounts !== true &&
			(isAdmin.value ||
				isTeam.value ||
				hasPersonalAccountsRolePermission(permissions.value))
	)

	return { canViewPersonalAccounts }
}

/**
 * Imperative Variante fuer Router-Guards (beforeEnter), wo kein Setup-Scope
 * vorhanden ist. Liest die Stores direkt.
 */
export function canViewPersonalAccountsNow(): boolean {
	const userStore = useUserStore()
	const clientStore = useClientStore()
	return (
		clientStore.canPersonalAccounts === true &&
		clientStore.settings?.hide_personal_accounts !== true &&
		(userStore.isAdmin ||
			userStore.isTeam ||
			hasPersonalAccountsRolePermission(userStore.permissions))
	)
}
